import React from 'react';

import { is } from 'helpers/ramda';

interface RenderProps {
  when: ((props: RenderProps) => boolean) | boolean;
  children: React.ReactNode;
  else?: ((props: RenderProps) => React.ReactNode) | React.ReactNode;
}

const getResult = <T>(key: ((props: RenderProps) => T) | T, props: RenderProps): T => {
  return is(Function, key) ? key(props) : key;
};

const Render: React.FC<RenderProps> = React.memo(props => {
  const { when, children, else: Else } = props;
  return getResult(when, props) ? children : getResult(Else, props);
});

export default React.memo(Render);
